export class MAAT_SOR_CODE {
  static readonly sorCodeLength = 9;
  static readonly sorCodeSuffixLength = 5;

  static readonly fakeSorCodeForNosJobItem = 'NOS';
  static readonly fakeSorCodeSuffixForNosJobItem = 'CINOS';
};
